module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ORIM-Blockquote-First"
  }, [_vm._v("“A child, more than all other gifts\u2028")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body"
  }, [_vm._v("That earth can offer to declining man,\u2028")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body"
  }, [_vm._v("Brings hope with it, and forward-looking thoughts.”\u2028")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Blockquote-Body"
  }, [_vm._v("—WORDSWORTH.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14796c52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled11.vue
// module id = 69
// module chunks = 0